import React from 'react';
import BaseComponent from 'meta/features/base-component';
import cn from 'classnames';
import './style.less';
/** Displays a progress bar at the top of the parent element. */
class ProgressBar extends BaseComponent {
    static defaultProps = {
        percent: -1,
        onTop: false,
        autoIncrement: false,
        intervalTime: 200,
        spinner: 'right'
    };
    interval;
    timeout;
    constructor(props) {
        super(props);
        this._bind('handleProps', 'increment');
        this.state = {
            percent: this.props.percent
        };
    }
    componentDidMount() {
        this.handleProps(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
        this.handleProps(nextProps);
    }
    componentWillUnmount() {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
    }
    increment() {
        let { percent } = this.state;
        percent = percent + (Math.random() + 1 - Math.random());
        percent = percent < 99 ? percent : 99;
        this.setState({
            percent: percent
        });
    }
    handleProps(props) {
        if (props.autoIncrement && props.percent >= 0 && props.percent < 99) {
            this.interval = window.setInterval(this.increment, props.intervalTime);
        }
        this.setState({
            percent: props.percent
        });
    }
    render() {
        let { onTop, spinner, className } = this.props;
        let { percent } = this.state;
        className = cn('react-progress-bar', className, {
            'react-progress-bar-on-top': onTop,
            'react-progress-bar-hide': percent < 0 || percent >= 100
        });
        let style = { width: (percent < 0 ? 0 : percent) + '%' };
        let spinnerClassName = cn('react-progress-bar-spinner', {
            [`react-progress-bar-spinner-${spinner}`]: spinner ? true : false
        });
        return (<div className={className}>
            <div className="react-progress-bar-percent" style={style}/>
            {spinner
                ? <div className={spinnerClassName}>
                        <div className="react-progress-bar-spinner-icon"></div>
                    </div>
                : null}
        </div>);
    }
}
export default ProgressBar;
